import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem 1.5rem;

  &:not(:last-child) {
    &:after {
      border: 0.5px solid
        ${({ theme }) => theme.themeColors.sidebars.bookmarks.dividerColor};
      content: '';
      height: 0;
      width: 100%;
    }
  }
`;

export const Page = styled.button`
  align-self: flex-start;
  appearance: none;
  background-color: transparent;
  border: 0;
  color: ${({ theme }) => theme.themeColors.sidebars.bookmarks.pagesColor};
  cursor: pointer;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.themeColors.sidebars.bookmarks.textColor};
  font-size: 1rem;
  line-height: 1.5;
  margin: 0.5em 0 1.25em 0;
`;
